import React from "react";
import "./style.css";
import Option from "./Option";
import Team from "../Team/Team";

const About = () => {
  const options1 = [
    {
      src: "option_1.png",
      alt: "option_1",
      optionName: "experienced coaches",
      optionDescription:
        "our coaches have specialized education. each of them knows the psychology of communication with children and will find an approach to each child",
    },
    {
      src: "option_2.png",
      alt: "option_2",
      optionName: "comfortable gym",
      optionDescription:
        "classes are held in a comfortable gym for children. soft carpet, high ceilings, large area",
    },
  ];

  const options2 = [
    {
      src: "option_3.png",
      alt: "option_3",
      optionName: "groups from 4 years old",
      optionDescription:
        "girls from 4 years old can do gymnastics in our club. we strengthen the health of your children and also teach them to socialize in society",
    },
    {
      src: "option_4.png",
      alt: "option_4",
      optionName: "individual approach",
      optionDescription:
        "every child is given due attention and the necessary assistance is provided. your children are in the safe hands of our professionals",
    },
  ];

  return (
    <div>
      <div className="aboutContainer" id="about">
        <h2>WHY TO CHOOSE US?</h2>
        {window.innerWidth > 600 ? (
          <div>
            <div className="optionsContainer">
              {options1.map(
                ({ src, alt, optionName, optionDescription }, index) => (
                  <Option
                    key={`${index}`}
                    src={src}
                    alt={alt}
                    optionName={optionName}
                    optionDescription={optionDescription}
                  />
                )
              )}
            </div>
            <div className="optionsContainer">
              {options2.map(
                ({ src, alt, optionName, optionDescription }, index) => (
                  <Option
                    key={`${index}`}
                    src={src}
                    alt={alt}
                    optionName={optionName}
                    optionDescription={optionDescription}
                  />
                )
              )}
            </div>
          </div>
        ) : (
          <div className="optionsContainer">
            {options1.map(
              ({ src, alt, optionName, optionDescription }, index) => (
                <Option
                  key={`${index}`}
                  src={src}
                  alt={alt}
                  optionName={optionName}
                  optionDescription={optionDescription}
                />
              )
            )}
            {options2.map(
              ({ src, alt, optionName, optionDescription }, index) => (
                <Option
                  key={`${index}`}
                  src={src}
                  alt={alt}
                  optionName={optionName}
                  optionDescription={optionDescription}
                />
              )
            )}
          </div>
        )}
      </div>
      <Team />
    </div>
  );
};

export default About;
